import { createFileRoute, redirect } from "@tanstack/react-router";
import { CheckoutPage } from "@majourneys/booking";
import { activitiesApi } from "../../../features/activities/api/activities.api";
import { activityKeys } from "../../../features/activities/constants/query-keys";
import { checkoutBlockReason, type CheckoutActivity } from "../../../features/activities/lib/checkout-guard";
import { transferHubRedirect } from "../../../features/transport/lib/hub-redirect";
import { withApi404 } from "../../../lib/route-loader";

export const Route = createFileRoute("/$lang/_layout/$slug/checkout")({
  loader: ({ params, context }) =>
    withApi404(async () => {
      const { queryClient } = context;
      const lang = params.lang;
      const response = await queryClient.ensureQueryData({
        queryKey: activityKeys.detail(params.slug, lang),
        queryFn: () => activitiesApi.getBySlug(params.slug, lang),
      });
      const a = response.data as CheckoutActivity & {
        slug?: string;
        category?: { slug?: string | null } | null;
      };
      const hub = transferHubRedirect(a, params.lang);
      if (hub) throw redirect(hub);
      // Explore items, restaurant tables and activities with no package have
      // no checkout. A flow page, so a normal (not 301) redirect, and the
      // guest's choices ride along in the query.
      if (checkoutBlockReason(a)) {
        throw redirect({
          to: "/$lang/$slug",
          params,
          search: (prev: Record<string, unknown>) => prev,
        });
      }
      return null;
    }),
  component: CheckoutPage,
});
